"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogicMetrics = void 0;
exports.LogicMetrics = {
    DeckCards: 52,
    NumberDecks: 2,
    SoftLimit: 17,
    TargetScore: 21,
    TotalRounds: 10,
    InitialChips: 1000,
    MinimumChips: 10,
    MaximumPlayers: 4,
};
